import React, { useEffect, useState } from 'react';
import { Container, Header, Image, Segment, Grid, Label, Button, Divider, Modal, Loader, Message } from 'semantic-ui-react';
import { withNamespaces, i18n } from '../i18n';
import actions from '../constants/actions.json';
import { withRouter } from 'next/router';
import Head from 'next/head';

const ActionDetails = ({ action, slug, language, t, i18n }) => {
	const [modalOpen, setModalOpen] = useState(false);
	const [selectedImage, setSelectedImage] = useState('');
	let actionPageTitle;
	let actionNotFoundMessage;
	let goToCollectActionText;

	switch (i18n.language) {
		case 'tr':
			actionPageTitle = "Aksiyon Bulunamadı";
			actionNotFoundMessage = "Aradığınız aksiyon mevcut değil.";
			goToCollectActionText = "Anasayfaya Dön";
			break;
		case 'en':
		default:
			actionPageTitle = "Action not found";
			actionNotFoundMessage = "The action you are looking for does not exist.";
			goToCollectActionText = "Back to Homepage";
			break;
	}

	if (!action) {
		return (
			<div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }} className="container">
				<Message negative>
					<Message.Header>{actionPageTitle}</Message.Header>
					<p>{actionNotFoundMessage}</p>
					<a href="/">
						<Button>
							{goToCollectActionText}
						</Button>
					</a>

				</Message>
			</div>
		);
	}
	const handleImageClick = (imgSrc) => {
		setSelectedImage(imgSrc);
		setModalOpen(true);
	};
	return (
		<div style={{ marginTop: '2em', marginBottom: '2em', minWidth: "100%" }}>
			<Head>
				<title>CollectAPI - {action.settings.title[i18n.language]}</title>
				<meta name="description" content={action.settings.description[i18n.language]} />
				<meta property="og:title" content={`CollectAPI - ${action.settings.title[i18n.language]}`} />
				<meta property="og:description" content={action.settings.description[i18n.language]} />
				<meta property="og:type" content="website" />
			</Head>

			<div style={{ display: 'flex', justifyContent: 'center' }}>
				<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
					<Image src={action.settings.image[i18n.language]} style={{ height: '50px' }} centered />
					<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', fontSize: '20px', textAlign: "center" }}>{action.settings.title[i18n.language]}</div>
				</div>
			</div>
			<Divider />
			<div style={{ textAlign: "center" }}>
				<p>{action.settings.description[i18n.language]}</p>
			</div>
			<Divider />
			<div style={{ marginBottom: "10px", display: "flex", gap: "10px", overflowX: "auto" }}>
				{action.settings.images[i18n.language].map((imgSrc, index) => (
					<Image key={index} src={imgSrc} style={{ marginBottom: '10px' }} centered size='large' onClick={() => handleImageClick(imgSrc)} />
				))}

			</div>

			<Modal
				open={modalOpen}
				onClose={() => setModalOpen(false)}
				size="large"
			>
				<Modal.Content image>
					<Image src={selectedImage} wrapped />
				</Modal.Content>
				<Modal.Actions>
					<Button onClick={() => setModalOpen(false)}>{t('close')}</Button>
				</Modal.Actions>
			</Modal>
			<Divider />
			<Segment>
				<div dangerouslySetInnerHTML={{ __html: action.settings.long_description[i18n.language] }} />
					<a 
					href={
						action.settings.slug[i18n.language] === 'RetentionTab' 
						? 'https://retentiontab.com/' 
						: i18n.language === 'en' 
							? `https://collectaction.com/en/action/${action.settings.slug[i18n.language]}` 
							: `https://collectaction.com/action/${action.settings.slug[i18n.language]}`
					} 
					target="_blank" 
					rel="noopener noreferrer"
					>
					<Button style={{ marginTop: '10px' }} secondary>
						{action.settings.slug[i18n.language] === 'RetentionTab' 
						? t('moreActionPageRetentionTab') 
						: t('moreActionPage')
						}
					</Button>
					</a>
			</Segment>
			<div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
				{action.organic_keyword[i18n.language].map((item, index) => (
					<Label key={index}>{item}</Label>
				))}
			</div>
		</div>
	);
};


ActionDetails.getInitialProps = async ({ req, query, asPath, i18n }) => {
	let slug = '';
	//let language = i18n.language;
	let action = null;
	// URL'den slug'ı çıkar
	const pathParts = asPath.split('/');
	slug = pathParts[pathParts.length - 1];


	let language = req.lng || 'tr'; //

	// Action'ı bul
	if (slug) {
		action = actions.find(a => a.settings.slug[language] === slug);
	}
	return {
		action,
		slug,
		language,
		namespacesRequired: ['common'],
	};
};

export default withRouter(withNamespaces()(ActionDetails));
